import React, { useState } from "react";
import Header from "./components/header";
import BetsUsers from "./components/bet-users";
import Main from "./components/Main";
// import { useCrashContext } from "./components/Main/context";
import propeller from "./assets/images/propeller.png";

import Context from "./context";
import Chat from "./components/Chat";
import FloatingSettings from "./components/FloatingSettings";

// import "./App.scss";

function App() {
  const { unityLoading, currentProgress, rechargeState, errorBackend, msgTab } =
    React.useContext(Context);
  const [howto, setHowto] = useState<any>("");
  return (
    <div className="main-container">
      <audio id="mainAudio" src="/sound/main.wav" loop></audio>
      <audio id="takeOffAudio" src="/sound/take_off.mp3"></audio>
      <audio id="flewAwayAudio" src="/sound/flew_away.mp3"></audio>
      <audio id="cashoutAudio" src="/sound/cashout.mp3"></audio>
      {errorBackend && (
        <div style={{
          position: 'fixed',
          top: '10px',
          right: '10px',
          background: '#ff4444',
          color: 'white',
          padding: '8px 16px',
          borderRadius: '4px',
          zIndex: 9999,
          fontSize: '12px'
        }}>
          ⚠️ Connection to server lost
        </div>
      )}
     
      {!unityLoading && (
        <div className="myloading">
          <div className="loading-container">
            <div className="rotation">
              <img alt="propeller" src={propeller}></img>
            </div>
            <div className="waiting">
              <div
                style={{ width: `${currentProgress * 1.111 + 0.01}%` }}
              ></div>
            </div>
            <p>{Number(currentProgress * 1.111 + 0.01).toFixed(2)}%</p>
          </div>
        </div>
      )}
      {rechargeState && (
        <div className="recharge">
          <div className="recharge-body">
            <div className="recharge-body-font">
              Insufficient balance amount
            </div>
            <a href="https://induswin.com/#/pages/recharge/recharge">
              Induswin.com
            </a>
          </div>
        </div>
      )}
      <Header />
      <div className={"game-container" + (msgTab ? " chat-open" : "")}>
        <div className="av-chat-panel"><Chat /></div>
        <Main />
        <BetsUsers />
      </div>
      {/* Floating Settings Button - Bottom Left */}
      <FloatingSettings setHowto={setHowto}/>
    </div>
  );
}

export default App;
